import script from "./DataTableStatistics.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataTableStatistics.vue?vue&type=script&setup=true&lang=ts"

import "./DataTableStatistics.vue?vue&type=style&index=0&id=2805a869&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2805a869"]])

export default __exports__